// services/strapiApi.js
import axios from "axios"

const STRAPI_URL = process.env.REACT_APP_STRAPI_URL || "http://localhost:1337"

const STRAPI_TOKEN = process.env.REACT_APP_STRAPI_TOKEN

const strapiApi = axios.create({
  baseURL: `${STRAPI_URL}/cms-api`,
  headers: {
    "Content-Type": "application/json",
    ...(STRAPI_TOKEN && { Authorization: `Bearer ${STRAPI_TOKEN}` }),
  },
})

export default strapiApi
